import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getTicketsFn = ({ page = 1, size = 20, sort = '', order = '', filters, selectedDealers }) =>
  restHelpers.withBearer.get(restHelpers.dealersQueryString(`${K.API_URL}/tickets?_=${new Date().getTime()}&page=${page - 1}&size=${size}${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}${filters ? '&' + filters : ''}`, selectedDealers));

const getTicketsCarHistoryFn = (carId, page = 1, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/tickets/cars/${carId}?_=${new Date().getTime()}&page=${page - 1}&size=10${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}`,
    {}
  );

const createTicketFn = (carId, type, description) => restHelpers.withBearer.post(`${K.API_URL}/tickets`, { data: { carId, type, description } });

const hasOpenTicketsFn = (carId) => restHelpers.withBearer.get(`${K.API_URL}/tickets/hasopentickets/${carId}?_=${new Date().getTime()}`);

const getTicketFn = (carId, ticketId) => restHelpers.withBearer.get(`${K.API_URL}/tickets/${carId}/${ticketId}/?_=${new Date().getTime()}`, {});

const createTicketCommentFn = (carId, ticketId, description) => restHelpers.withBearer.post(`${K.API_URL}/tickets/comment`, { data: { carId, ticketId, description } });

const createTicketFileFn = (carId, ticketId, fileList) => restHelpers.withBearer.file(`${K.API_URL}/tickets/${carId}/${ticketId}/file`, { data: fileList });

const getTicketCarFiltersFn = () => restHelpers.withBearer.get(`${K.API_URL}/tickets/cars/filters?_=${new Date().getTime()}`);

export default {
  getTickets: getTicketsFn,
  getTicketsCarHistory: getTicketsCarHistoryFn,
  createTicket: createTicketFn,
  hasOpenTickets: hasOpenTicketsFn,
  getTicket: getTicketFn,
  createTicketComment: createTicketCommentFn,
  createTicketFile: createTicketFileFn,
  getTicketCarFilters: getTicketCarFiltersFn
};
